// frontend/src/pages/Home.tsx
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import Hero from '../components/Home/Hero';
import AboutSection from '../components/Home/AboutSection';
import ProjectsSection from '../components/Home/ProjectsSection';
import ImpactStats from '../components/Home/ImpactStats';
//import Testimonials from '../components/Home/Testimonials';
import Partners from '../components/Home/Partners';
import { ImpactStats as ImpactData } from '../types';

const Home: React.FC = () => {
  const [impactData, setImpactData] = useState<ImpactData | null>(null);

  useEffect(() => {
    const fetchImpactData = async () => {
      try {
        const response = await axios.get('http://localhost/iga/backend/api/impact-stats');
        setImpactData(response.data);
      } catch (error) {
        console.error('Error fetching impact data:', error);
      }
    };

    fetchImpactData();
  }, []);

  return (
    <>
      <Helmet>
        <title>Impact Generation Africa - Sustainable Food Security & Climate Resilience</title>
        <meta 
          name="description" 
          content="Join Impact Generation Africa in creating sustainable food security and climate resilience through community-based projects, youth empowerment, and environmental conservation." 
        />
      </Helmet>

      <Hero />
      
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <AboutSection />
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <ImpactStats data={impactData} />
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        <ProjectsSection />
      </motion.div>

      <Partners />
    </>
  );
};

export default Home;